import React from 'react';

import incompletebluestep from '../../../images/incompletebluestep.svg';

import { FOHImage } from '../../ingredients';

export const FOHBlueNextStepIcon = (props: any) => (
  <FOHImage
    source={{ uri: incompletebluestep }}
    style={{ width: 25, height: 25, ...props.style }}
  />
);
